<template>
  <div class="how-to">

    <div class="apps-container">

      <div
      ontouchstart=""
      class="app-container white">
        <div class="app-icon">
          <comp-icon
          v-bind:icon="'link'"
          v-bind:width="72"></comp-icon>
        </div>
        <div class="app-title">Psap link</div>
      </div>

      <div
      v-on:click="onClickVerification" ontouchstart=""
      class="app-container blue">
        <div class="app-icon">
          <comp-icon
          v-bind:icon="'phoneSpeaker'"
          v-bind:width="72"></comp-icon>
        </div>
        <div class="app-title">Verification</div>
      </div>
      
    </div>

    <div class="instruction-container">{{instructionText}}</div>
            
  </div>
</template>

<script>
import CompIcon from '@/components/CompIcon'
export default {
  name: 'how-to',
  components: {
    CompIcon
  },
  data: function () {
    return {
      instructionText: 'Welcome to the CHeKT share portal. Click icon to view the detail of each application.'
    }
  },
  methods: {
    onClickVerification: function () {
      this.$router.push({name: 'Verification', query: this.$route.query})
    },
    getDealerLogo: function () {
      let dealerLogo = ''
      const idToken = this.$token.getIdTokenFromQuery()
      if (this.$token.hasValidToken()) {
        this.$store.commit('UPDATE_IDTOKEN', {
          idToken: idToken
        })
        if (idToken) {
          let object = this.$tool.decodeJwtToken(idToken)
          if ('dealer_logo_url' in object) {
            this.$store.commit('UPDATE_DEALER_LOGO', {
              dealerLogo: object['dealer_logo_url']
            })
            this.dealerLogo = object['dealer_logo_url']
            dealerLogo = object['dealer_logo_url']
          }
        }
      }
      return dealerLogo
    }
  },
  metaInfo () {
    return {
      meta: [
        {property: 'og:image', content: this.getDealerLogo()}
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.how-to {
  /* common */
  background-color: #fff;
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: relative;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.how-to .apps-container {
  /* size */
  width: 100%;
  height: calc(100% - 2em);
  /* position */
  position: relative;
  top: 2em;
  /* alignment */
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.how-to .apps-container .app-container {
  /* common */
  background-color: hsla(0, 0%, 10%, 1);
  color: #fff;
  /* mouse */
  cursor: pointer;
  /* size */
  padding: 1em;
  width: calc(50% - 2em);
  height: calc(100% - 2em);
  min-width: 100px;
  /* alignment */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.how-to .apps-container .app-container.white {
  /* common */
  background-color: #fff;
  color: #333;
}

.how-to .apps-container .app-container.blue {
  /* common */
  background-color: hsla(202, 100%, 50%, 1);
  color: #333;
}

.how-to .apps-container .app-container .app-icon {
  /* common */
  background-color: #fff;
  color: #333;
  /* size */
  width: 100px;
  height: 100px;
  /* shape */
  border-radius: 10px;
  border-radius: 50%;
  /* style */
  box-shadow: 0 0 4px 0 hsla(0, 0%, 0%, 0.5);
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.how-to .apps-container .app-container:hover .app-icon {
  /* style */
  box-shadow: 0 0 6px 0 hsla(0, 0%, 0%, 0.5);
}
.how-to .apps-container .app-container:active .app-icon {
  /* style */
  box-shadow: 0 0 1px 0 hsla(0, 0%, 0%, 0.5);
}

.how-to .apps-container .app-container .app-title {
  /* text */
  font-weight: bold;
  text-transform: uppercase;
  /* size */
  margin-top: 1em;
}

.how-to .instruction-container {
  /* common */
  background-color: #000;
  color: #fff;
  /* size */
  width: calc(100% - 2em);
  height: 3em;
  padding: 0 1em;
  font-size: 0.95rem;
  /* position */
  position: absolute;
  top: 0;
  left: 0;
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/HowTo.vue